/**
 * Internal dependencies
 */
import {
    SUBSCRIPTIONS_RECEIVE,
    SUBSCRIPTIONS_REQUEST,
    SUBSCRIPTIONS_REQUEST_SUCCESS,
    SUBSCRIPTIONS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllSubscriptions, requestingSubscriptions } from './selectors';


const recieveSubscriptions = (items) => ({
    type: SUBSCRIPTIONS_RECEIVE,
    payload: { items },
});

/**
 * [description]
 *
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestSubscriptions = (includeSupport = false) => (dispatch) => {
    dispatch({
        type: SUBSCRIPTIONS_REQUEST,
    });
    return cscom
        .subscription()
        .list()
        .then((subscriptions) => {
            dispatch({
                type: SUBSCRIPTIONS_REQUEST_SUCCESS,
            });
            dispatch(recieveSubscriptions(subscriptions));
            return subscriptions;
        })
        .catch((error) => {
            dispatch({
                type: SUBSCRIPTIONS_REQUEST_FAILURE,
                error,
            });
        });
};


/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestSubscriptionsIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const subscriptions = getAllSubscriptions(getState());
	const requesting = requestingSubscriptions(getState());

	if (subscriptions.length == 0 && requesting == false) {
		return dispatch(requestSubscriptions(...props))
	}

	return subscriptions;
}


/**
 * [description]
 *
 * @param  {[type]} subscriptionId [description]
 * @param  {[type]} newPlanId)     [description]
 * @return {[type]}                [description]
 */
export const swapSubscription = (subscriptionId, newPlanId) => (dispatch) => {
    return cscom
        .subscription()
        .swap(subscriptionId, newPlanId)
        .then((subscription) => {
            dispatch(recieveSubscriptions([subscription]));
            return subscription;
        });
};

/**
 * [description]
 *
 * @param  {[type]} subscriptionId) [description]
 * @return {[type]}                 [description]
 */
export const removeScheduledChanges = (subscriptionId) => (dispatch) => {
    return cscom
        .subscription()
        .removeScheduledChanges(subscriptionId)
        .then((subscription) => dispatch(recieveSubscriptions([subscription])));
};
